<template>
  <div
    id="integrationSetting"
    class="mx-5"
  >
    <div class="mt-2 d-flex justify-space-between">
      <div class="d-flex">
        <v-img
          contain
          :max-width="40"
          :src="require(`@/assets/conectiontab/neto.svg`)"
          class="mx-3 mt-1"
        />
        <h2
          style="line-height:85px;"
          class="mr-3"
        >
          Neto
        </h2>
      </div>
      <v-col cols="1">
        <v-btn
          class="text-right mt-3"
          icon
          @click.stop="
            $store.commit('ui/drawer.right.toggle')
          "
        >
          <v-icon
            style="background-color:transparent"
            medium
          >
            mdi-close
          </v-icon>
        </v-btn>
      </v-col>
    </div>
    <div class="mx-3">
      <v-card
        outlined
        class="update-card mb-5"
      >
        <v-row class="px-3 pt-3">
          <v-col cols="1">
            <v-icon
              color="#3FD06F"
              class="mr-3"
              style="font-size:35px;"
            >
              mdi-checkbox-marked-circle
            </v-icon>
          </v-col>
          <v-col class="ml-1">
            <v-row><h2>Integration Update</h2> </v-row>
            <v-row class="mt-2 pr-2">
              <p v-if="syncingStatus">
                You just added the Neto integration. We are syncing the data right now and you should check back in a few minutes. As you continue to use Neto, we will automatically keep that data in sync with Maropost.
              </p>
              <p v-else>
                You just added the Neto integration. As new contacts and orders get created to your Neto store we will import them into the Maropost list you have selected.
              </p>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
     <div id="neto-intergration-details">
        <h2>Integration Info</h2>
        <v-sheet class="pa-3" v-if="isLoading">
          <v-skeleton-loader
            class="mx-auto"
            type="article"
            :loading="isLoading"
          >
          </v-skeleton-loader>
        </v-sheet>

        <div class="mt-5 py-2 px-3 bg-grey" v-else>
          <v-row class="py-2">
            <v-col cols="3" class="py-0 font-weight-light">
              Shop URL
            </v-col>
            <v-col class="py-0">
              {{ storeData.organization_name }}
            </v-col>
          </v-row>
          <v-row class="py-2">
            <v-col cols="3" class="py-0 font-weight-light">
              Shop Name
            </v-col>
            <v-col class="py-0">
              {{ storeData.nick_name }}
            </v-col>
          </v-row>
          <v-row class="py-2">
            <v-col cols="3" class="py-0 font-weight-light">
              Maropost List
            </v-col>
            <v-col class="py-0">
              {{ listName }}
            </v-col>
          </v-row>
          <v-row class="py-2">
            <v-col cols="3" class="py-0 font-weight-light">
              Status
            </v-col>
            <v-col class="py-0">
              <v-chip
                small
                outlined
                dark
                class="mt-1 mr-3"
                :color="storeData.active ? '#41CE65': '#FFB933' "
              >
                {{ storeData.active ? 'Active' : 'Processing' }}
              </v-chip>
            </v-col>
          </v-row>
        </div>
      </div>
 
     
      <div class="my-5">
        <h2>Neto Fields Mapping to Maropost Fields</h2>
        <v-simple-table
          outlined
          class="mt-5 field-table"
        >
          <thead class="bg-grey">
            <tr>
              <th class="text-left">
                Maropost Fields
              </th>
              <th class="text-left">
                Neto Fields
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(field, index) in fields"
              :key="index"
            >
              <td :class="{ 'bg-grey': field.neto == '' }">
                {{ field.maropost }}
              </td>
              <td :class="{ 'bg-grey': field.neto == '' }">
                {{ field.neto }}
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </div>

      <v-btn
        id="neto-store-index"
        dark
        :to="'/accounts/' + $store.getters['auth/account'].id + '/integrations/neto'"
        class="mb-5"
        @click="navigateIndexPage()"
      >
        Done
      </v-btn>
    </div>
  </div>
</template>

<script>
  import { $integrations, $lists } from '@/services'
  import isEmpty from 'lodash/isEmpty'

  const {getListStats} =  $lists;

  export default {
    name: 'NetoDetailDrawer',
    data () {
      return {
        listDetails:{name :""},
        isLoading:false,
        fields: [
          {
            maropost: 'For Orders:',
            neto: '',
          },
          {
            maropost: 'grand_total',
            neto: 'GrandTotal',
          },
          {
            maropost: 'original_order_id',
            neto: 'OrderID',
          },
          {
            maropost: 'order_date',
            neto: 'DatePlaced',
          },
          {
            maropost: 'order_status',
            neto: 'OrderStatus',
          },
          {
            maropost: 'Contact records come from Maropost neto Cloud as a hash of email address, first name, and last name:',
            neto: '',
          },
          {
            maropost: 'first_name',
            neto: 'BillFirstName',
          },
          {
            maropost: 'last_name',
            neto: 'BillLastName',
          },
          {
            maropost: 'email',
            neto: 'Email/EmailAddress',
          },
          {
            maropost: 'status',
            neto: 'NewsLetterSubscriber',
          },
          {
            maropost: 'For products:',
            neto: '',
          },
          {
            maropost: 'item_id',
            neto: 'SKU',
          },
          {
            maropost: 'quantity',
            neto: 'Quantity',
          },
          {
            maropost: 'description',
            neto: 'Name',
          },
          {
            maropost: 'brand',
            neto: 'Brand',
          },
          {
            maropost: 'name',
            neto: 'Name',
          },
          {
            maropost: 'price',
            neto: 'UnitPrice',
          },
          {
            maropost: 'categories',
            neto: 'CategoryName',
          },
          {
            maropost: 'img_url',
            neto: 'Images[URL]',
          },
          {
            maropost: 'status',
            neto: 'IsActive',
          },
          {
            maropost: 'published',
            neto: 'Approved',
          },
          {
            maropost: 'availability',
            neto: 'AvailableSellQuantity',
          },
          {
            maropost: 'product_price',
            neto: 'DefaultPrice',
          },
          {
            maropost: 'For Carts:',
            neto: '',
          },
          {
            maropost: 'orignal_cart_id',
            neto: 'CartId',
          },
          {
            maropost: 'restore_url',
            neto: 'RestoreCartUrl',
          },
          {
            maropost: 'status',
            neto: 'CheckoutStatus',
          },
          {   
            maropost: 'For Content',
            neto: '',
          },
          {   
            maropost: 'original_id',
            neto: 'ID'
          },
          {   
            maropost: 'name',
            neto: 'ContentName'
          },
          {   
            maropost: 'parent_id',
            neto: 'ParentContentID'
          },
          {
            maropost: "Custom Fields",
            neto: ""
          },
        ],
        storeData: {},
        syncingStatus: true,
      }
    },
    computed: {
      listName () {
        return  !isEmpty(this.listDetails)?this.listDetails.name:  localStorage.getItem('selected_integration_list_name') 
      },
    },
    mounted () {
      this.getStoreDetail(this.$store.getters['ui/drawer'].right.crm_id)
    },
    methods: {
      navigateIndexPage () {
        localStorage.removeItem('selected_integration_list_name')
        this.$router.push({ name: 'Neto_index' })
      },
      getStoreDetail (storeId) {
        this.isLoading = true;
        $integrations.getStoreDetail('neto', storeId)
          .then(res => {
            this.storeData = res.data.crm
            this.syncingStatus = res.data.sync_old_data || true
            if(!isEmpty(this.storeData.crm_lists)) this.getListDetails(this.storeData.crm_lists[0])
            Object.keys(this.storeData.data).forEach(key => {
              this.fields.push({maropost: key, neto: this.storeData.data[key]})
            });
          })
          .catch(error => {
            this.isLoading = false;
            this.$store.commit('ui/snackbar', {
              message: error,
              type: 'error',
            })
          })
      },
      /**
       * Fetches details of contact list whose integration have been successfully done
       */
  async getListDetails({list_id}) {
      try {
        if(!list_id) return;
        this.isLoading = true;
        const { data } = await getListStats( list_id);
        this.listDetails = data;
      } catch (error) {
        this.$store.commit("ui/snackbar", {
          message: error.message,
          type: "warning"
        });
      } finally {
        this.isLoading = false;
      }
    }
    },
  }
</script>

<style scoped>
.bg-grey {
  background-color: #f4f4f4;
}
.update-card{
  border: 1px solid #3BCF6C !important;
}
.field-table{
  border: 1px solid rgba(0, 0, 0, 0.12);
}
</style>
